import cn from 'classnames'
import { FloatingActionButton } from 'components/Custom/index'
import { Box } from 'components/Material/index'
import { useIsMobile } from 'hooks/useIsResponsive'
import React from 'react'

type MainContainerProps = {
  children: React.ReactNode
  className?: string
  isSidebarOpen?: boolean
  showButton?: boolean
  bgColor?: 'white' | 'dark'
}

export const MainContainer = ({
  children,
  className,
  isSidebarOpen,
  showButton = true,
  bgColor = 'white'
}: MainContainerProps) => {
  const isMobile = useIsMobile()
  const mainContainerStyles = {
    'flex flex-col w-full h-full min-h-0 overflow-hidden relative': true,
    'md:mr-[390px]': isSidebarOpen,
    'bg-black': bgColor === 'dark',
    'bg-gray-10': bgColor === 'white'
  }

  return (
    <Box className={cn(mainContainerStyles, className)}>
      {children}
      {showButton && (!isSidebarOpen || !isMobile) && <FloatingActionButton />}
    </Box>
  )
}
